import {ContractTypes} from 'utility/utility'
import {object, string, number, bool} from 'yup'

export const BusinessSchema = object().shape({
  name: string().max(255, 'Name too long!').required('Name is required!'),
  address: string().max(512, 'Address too long!'),
  postalCode: string().max(20, 'Postal code is too long!'),
  phone: string().max(20, 'Phone number too long!'),
  logo: string().url('Logo must be url, or uploaded one!').optional(),
  accountNumber: string().max(20, 'Account number too long!').optional(),
  contractType: string().required('Contract type is required'),
  distributor: string().optional(),
  reseller: string().optional(),
  options: object().shape({
    whiteboardAccess: bool().optional(),
    browserAccess: bool().optional(),
    digitalSignageAccess: bool().optional(),
    externalCallingAccess: bool().optional(),
    videoResolutionsAccess: bool().optional(),
  }).optional(),
  licenses:  object().shape({
    device: object().shape({
      type: string(),
      licenses: number().optional()
    }).optional(),
    remote: object().shape({
      type: string(),
      licenses: number().optional()
    }).optional(),
  }).optional(),
  trialExpiry: string().when('contractType', {
    is: value => value === ContractTypes.Trial,
    then: () => string().required('Trial expiry date is required!')
  }),
  contractExpiry: string().when('contractType', {
    is: value => value === ContractTypes.Customer,
    then: () => string().required('Contract expiry date is required!')
  })
})

export const BusinessPrototype = {
  name: '',
  address: '',
  postalCode: '',
  phone: '',
  logo: '',
  accountNumber: '',
  contractType: ContractTypes.Trial,
  distributor: '',
  reseller: '',
  trialExpiry: '',
  contractExpiry: '',
  options: {
    whiteboardAccess: true,
    browserAccess: true,
    digitalSignageAccess: false,
    externalCallingAccess: false,
    videoResolutionsAccess: false,
  },
  licenses: {
    device: {
      type: 'limited',
      licenses: 0
    },
    remote: {
      type: 'limited',
      licenses: 0
    }
  },
}
